import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { AppProvider } from "./AppProvider";
import { CookiesProvider } from "react-cookie";
import { MobileProvider } from "./MobileProvider";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";

if (process.env.NODE_ENV !== "development") {
  disableReactDevTools();
}

const root = createRoot(document.getElementById("root") as HTMLDivElement);
root.render(
  <StrictMode>
    <BrowserRouter>
      <CookiesProvider>
        <MobileProvider>
          <AppProvider>
            <App />
            <ScrollToTop />
          </AppProvider>
        </MobileProvider>
      </CookiesProvider>
    </BrowserRouter>
  </StrictMode>
);
